<template>
    <v-dialog v-model="active" max-width="400px" persistent class="l-dialog">
        <template v-slot:activator="{}">
            <v-btn block outlined class="view-btn" @click="loadHistorico()" :loading="loading">
                <v-icon small>fas fa-history</v-icon>
            </v-btn>
        </template>
        <v-card class="l-card" height="100%">
            <v-container fluid class="background pa-0 l-card__title__container">
                <v-row align="center" class="ma-0 l-card__title__row">
                    <v-col cols="12" class="pa-4">
                        <span class="l-card__title__text">Histórico de alterações</span>
                    </v-col>
                    <v-btn absolute right top icon x-small color="#E5E8E7" @click="active = !active">
                        <v-icon>fa fa-times</v-icon>
                    </v-btn>
                </v-row>
            </v-container>
<!--    // Timelines passadas -->
            <v-container fluid class="pa-0 ma-0 l-card__content__container_c">
                <v-row align="center" class="ma-0 l-card__filter__row pl-5"  md-gutter
                        v-for="status in listaStatusHistorico" :key="status.idPlanejamentoAlojamentoStatus">
                    <v-col cols="2">
                        <v-icon v-if="status.cdStatusPlanejamentoAlojamento !== 7" class="icon-stats">
                            fas fa-check-circle
                        </v-icon>
                        <v-icon v-else class="icon-stats-exclamation">
                            fas fa-exclamation-circle
                        </v-icon>
                    </v-col>
                    <v-col cols="10">
                        <span class="text-date-history text-capitalize">
                            {{ status.dhStatus | formataData(true, 'dddd') }} - {{ status.dhStatus | formataData(true, 'DD/MM') }}
                        </span>
                        <br/>
                        <span class="text-stats-history">
                            {{ status.cdStatusPlanejamentoAlojamento | formatStatusDisplayAPI(statusTypes) }}
                        </span>
                        <br/>
                        <span class="text-user-history">Por {{ status.nmUser }}</span>
                    </v-col>
                    <v-col cols="12" class="ma-0 pa-0">
                        <v-divider/>
                    </v-col>
                </v-row>
            </v-container>
<!--    // Timelines futuras -->
            <v-container fluid class="pa-0 ma-0 l-card__content__container_c"
                         v-for="(etapas, index) in etapasFuturas"
                         :key="etapas.idStatusPlanejamentoAlojamento">
                <v-row align="center" class="ma-0 l-card__filter__row pl-5" md-gutter>
                    <v-col cols="2">
                        <v-icon class="icon-stats-not-informed">
                            {{ etapasFuturas[index + 1]  ? 'far fa-circle' : 'fas fa-circle' }}
                        </v-icon>
                    </v-col>
                    <v-col cols="10">
                        <span class="text-stats-history">{{ etapas.idStatusPlanejamentoAlojamento | formatStatusDisplayAPI(statusTypes) }}</span>
                    </v-col>
                    <v-col cols="12" class="ma-0 pa-0">
                        <v-divider/>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
import moment from "moment";

export default {
    name: "HistoricoPlanejamentoDialog",
    props: {
        item: {
            type: Object,
        },
        statusTypes: {
            type: Array
        }
    },
    data: () => ({
        active: false,
        loading: false,
        listaStatusHistorico: []
    }),
    computed: {
        etapasFuturas() {
            return this.statusTypes.filter(type => type.idStatusPlanejamentoAlojamento > this.item.cdStatusPlanejamentoAlojamento
                                        && type.idStatusPlanejamentoAlojamento < 5)
                .sort((a, b) => a.idStatusPlanejamentoAlojamento - b.idStatusPlanejamentoAlojamento)
        }
    },
    methods: {
        loadHistorico() {
            this.listaStatusHistorico = []
            this.loading = true
            this.$axios(
                `/planejamento-alojamento/${this.item.idPlanejamentoAlojamento}/historico/`
            ).then((res) => {
                if (!res.data) return;
                if (!res.data.length > 0) return;
                if (!res.data[0].data) return;

                this.listaStatusHistorico = res.data[0].data.sort(
                    (a, b) => a.idPlanejamentoAlojamentoStatus - b.idPlanejamentoAlojamentoStatus
                );

                this.active = true
            })
            .catch((err) => {
                this.$store.commit("setSnack", {
                    type: "error",
                    msg: err
                })
            })
            .finally(() => this.loading = false)
        },
    },
    filters: {
        formataData(date, ISO, formatoSaida) {
            let tipoData = ISO ? moment.ISO_8601 : 'YYYY-MM-DD';
            const parsedDate = moment(date, tipoData);
            if (!parsedDate.isValid()) return "";
            return parsedDate.format(formatoSaida);
        },

        formatStatusDisplayAPI(value, statusTypes) {
            const status = statusTypes.find(type => type.idStatusPlanejamentoAlojamento === value)
            if (!status) return ""
            return status.nmStatus
        },

        formatWeekDay(value) {
            let m = moment(value);
            let text = m.format("dddd");
            return text.substring(0, 3);
        },
        formatDay(value) {
            let m = moment(value);
            return m.format("DD/MM");
        },
    },
};
</script>

<style scoped>
.text-date-history {
    text-align: left;
    font: normal 10px Roboto;
    letter-spacing: 0.4px;
    color: #10303d;
    text-transform: uppercase;
    opacity: 0.7;
}

.text-stats-history {
    text-align: left;
    font: medium 16px Roboto;
    letter-spacing: 0px;
    color: #10303d;
    opacity: 0.7;
}

.text-user-history {
    text-align: left;
    font: normal 12px Roboto;
    letter-spacing: 0px;
    color: #10303d;
    opacity: 0.7;
}

.icon-stats {
    color: #0ca5a2 !important;
    opacity: 1 !important;
}

.icon-stats-exclamation {
    color: #f5b800 !important;
    opacity: 1 !important;
}

.icon-stats-not-informed {
    color: #7b9596 !important;
    opacity: 1 !important;
}

.view-btn {
  border: 1px solid #e5e8e7;
  border-radius: 4px;
  color: #10303d;
  width: 100%;
}

</style>